import { createContext, useContext, type ReactNode } from "react";

interface SidebarContextValue {
  collapsed: boolean;
}

const SidebarContext = createContext<SidebarContextValue>({ collapsed: false });

export function SidebarProvider({
  collapsed,
  children,
}: {
  collapsed: boolean;
  children: ReactNode;
}) {
  return <SidebarContext.Provider value={{ collapsed }}>{children}</SidebarContext.Provider>;
}

export function useSidebarCollapsed(): boolean {
  return useContext(SidebarContext).collapsed;
}
